import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import ElectricalPOS from '@/components/ElectricalPOS';

const electricalStore = () => {
    return (
        <>
            <Head>
                <title>Electrical Stores Billing Software| Electrical Shop POS</title>
                <link rel="canonical" href="https://queuebuster.co/outlet/electrical-store" />
                <link rel="alternate" href="https://queuebuster.co/outlet/electrical-store" hrefLang="en-us" />
                <meta name="description" content="Manage electronics stores with QueueBuster POS. Fast, secure transactions, multi-store management, cloud flexibility, easy UI, and seamless integrations for growth." />
                <meta property="og:title" content="QueueBuster POS for Electricals Stores: Fast, Secure, and Scalable for Growing Businesses" />
                <meta property="og:description" content="Elevate your Electricals store with QueueBuster POS. Fast, secure transactions, real-time multi-store management, cloud flexibility, easy-to-use interface, and seamless integrations with e-commerce and accounting systems to ensure smooth operations and growth." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-02.jpg" />
                <meta property="og:url" content="https://queuebuster.co/outlet/electrical-store" />
            </Head>
         <SchemaTags page="electrical-store" />
            <ElectricalPOS />
        </>
    )
}

export default electricalStore